










import { Component, Vue, Watch, Prop} from 'vue-property-decorator'
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
@Component({
    name:''
})
export default class ProjectManage extends AbpBase  {
    @Prop() currentName:string;
    bool:boolean = true;
    ToPage(name:any) {
        this.bool = false;
        this.$nextTick(function () {
            this.bool = true;
        });
        this.$router.push({name: name});
    }
}
